import { render, staticRenderFns } from "./AccountsTree.vue?vue&type=template&id=0205de6a&scoped=true&"
import script from "./AccountsTree.vue?vue&type=script&lang=js&"
export * from "./AccountsTree.vue?vue&type=script&lang=js&"
import style0 from "./AccountsTree.vue?vue&type=style&index=0&id=0205de6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0205de6a",
  null
  
)

export default component.exports